// Utility functions to get device and browser information

export const getBrowserInfo = () => {
  const userAgent = navigator.userAgent;
  let browserName = "Unknown";
  let browserVersion = "Unknown";

  // Chrome
  if (userAgent.indexOf("Chrome") > -1 && userAgent.indexOf("Edg") === -1) {
    browserName = "Chrome";
    const chromeMatch = userAgent.match(/Chrome\/([0-9\.]+)/);
    if (chromeMatch) {
      browserVersion = chromeMatch[1];
    }
  }
  // Edge
  else if (userAgent.indexOf("Edg") > -1) {
    browserName = "Microsoft Edge";
    const edgeMatch = userAgent.match(/Edg\/([0-9\.]+)/);
    if (edgeMatch) {
      browserVersion = edgeMatch[1];
    }
  }
  // Firefox
  else if (userAgent.indexOf("Firefox") > -1) {
    browserName = "Firefox";
    const firefoxMatch = userAgent.match(/Firefox\/([0-9\.]+)/);
    if (firefoxMatch) {
      browserVersion = firefoxMatch[1];
    }
  }
  // Safari
  else if (
    userAgent.indexOf("Safari") > -1 &&
    userAgent.indexOf("Chrome") === -1
  ) {
    browserName = "Safari";
    const safariMatch = userAgent.match(/Version\/([0-9\.]+)/);
    if (safariMatch) {
      browserVersion = safariMatch[1];
    }
  }
  // Internet Explorer
  else if (userAgent.indexOf("Trident") > -1) {
    browserName = "Internet Explorer";
    const ieMatch = userAgent.match(/rv:([0-9\.]+)/);
    if (ieMatch) {
      browserVersion = ieMatch[1];
    }
  }

  return {
    browser: browserName,
    browserVersion: browserVersion,
  };
};

export const getDeviceInfo = () => {
  const userAgent = navigator.userAgent;
  let os = "Unknown";
  let deviceType = "Desktop";

  // Detect Operating System
  if (userAgent.indexOf("Windows") > -1) {
    os = "Windows";
    if (userAgent.indexOf("Windows NT 10.0") > -1) os += " 10";
    else if (userAgent.indexOf("Windows NT 6.3") > -1) os += " 8.1";
    else if (userAgent.indexOf("Windows NT 6.2") > -1) os += " 8";
    else if (userAgent.indexOf("Windows NT 6.1") > -1) os += " 7";
  } else if (userAgent.indexOf("Mac") > -1) {
    os = "macOS";
  } else if (userAgent.indexOf("Linux") > -1) {
    os = "Linux";
  } else if (userAgent.indexOf("Android") > -1) {
    os = "Android";
    deviceType = "Mobile";
  } else if (
    userAgent.indexOf("iPhone") > -1 ||
    userAgent.indexOf("iPad") > -1
  ) {
    os = "iOS";
    deviceType = userAgent.indexOf("iPad") > -1 ? "Tablet" : "Mobile";
  }

  // Detect if mobile/tablet
  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      userAgent
    );
  const isTablet =
    /iPad|Android(?=.*\bMobile\b)(?=.*\bSafari\b)|Android(?=.*(?:\bTablet\b|\bSM-T))/i.test(
      userAgent
    );

  if (isMobile && !isTablet) {
    deviceType = "Mobile";
  } else if (isTablet) {
    deviceType = "Tablet";
  }

  // Get screen resolution
  const screenResolution = `${window.screen.width}x${window.screen.height}`;

  // Get timezone
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return {
    deviceInfo: `${os} - ${deviceType} - ${screenResolution} - ${timezone}`,
    operatingSystem: os,
    deviceType: deviceType,
    screenResolution: screenResolution,
    timezone: timezone,
  };
};

export const getClientIP = async () => {
  try {
    // Sử dụng service public để lấy IP
    const response = await fetch("https://api.ipify.org?format=json");
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error("Error getting client IP:", error);
    return null;
  }
};

export const generateSessionId = () => {
  // Tạo session ID unique
  return (
    "session_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9)
  );
};

// Function to collect all login information
export const getLoginInfo = async (userId, userName) => {


  const browserInfo = getBrowserInfo();
  

  const deviceInfo = getDeviceInfo();
  

 
  const clientIP = await getClientIP();
  

  const sessionId = generateSessionId();
  

  // Tạo thời gian địa phương theo format YYYY-MM-DDTHH:mm:ss
  const now = new Date();
  const localDateTime = new Date(
    now.getTime() - now.getTimezoneOffset() * 60000
  )
    .toISOString()
    .slice(0, 19);

  const loginInfo = {
    userId: userId,
    sessionId: sessionId,
    loginTime: localDateTime,
    ipAddress: clientIP,
    deviceInfo: deviceInfo.deviceInfo,
    browser: browserInfo.browser,
    browserVersion: browserInfo.browserVersion,
    createBy: userName,
  };



  return loginInfo;
};
